import React, { FunctionComponent } from 'react'
import { useAppSelector } from '../../../state/hooks'
import {
  selectLineItems,
  selectPotentialPromotionId,
  selectCurrentSale,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { hasServiceOrder } from '../../../functions/service'
import {
  isBlindReturn,
  isLegacyServiceSale,
  isMarkedAsUnfulfilled,
  hasUnknownLineItems,
} from '../../../functions/sale'
import { SalePromotionBanner } from '../sale-promotion/SalePromotionBanner'
import { useSaleManager, useUserManager } from '../../../ng-compat/hooks'
import { SaleServiceBanner } from '../sale-service/SaleServiceBanner'
import { SaleReturnBanner } from '../sale-return/SaleReturnBanner'
import { PERMISSIONS } from '../../../constants'
import { SaleErrorBanner } from '../sale-error/SaleErrorBanner'

export const SaleBanner: FunctionComponent = () => {
  const sale = useAppSelector(selectCurrentSale)
  const saleManager = useSaleManager()
  const userManager = useUserManager()
  const lineItems = useAppSelector(selectLineItems)
  const potentialPromotionId = useAppSelector(selectPotentialPromotionId)

  const shouldShowPromoBanner = () => {
    return Boolean(
      saleManager.getHasActivePromotions() &&
        lineItems.length > 0 &&
        potentialPromotionId &&
        !shouldShowSaleErrorBanner() &&
        !shouldShowServiceBanner()
    )
  }

  const shouldShowServiceBanner = () => {
    const shouldShowForServices =
      hasServiceOrder(sale.serviceFields, sale.customFields) ||
      isLegacyServiceSale(sale.status)

    return Boolean(!shouldShowSaleErrorBanner() && shouldShowForServices)
  }

  const shouldShowBlindReturnBanner = () => {
    return Boolean(
      userManager.hasPermission(PERMISSIONS.SALE_RETURN) &&
        isBlindReturn(sale) &&
        !shouldShowSaleErrorBanner() &&
        !shouldShowPromoBanner() &&
        !isMarkedAsUnfulfilled(sale.status) &&
        !isLegacyServiceSale(sale.status)
    )
  }

  const shouldShowSaleErrorBanner = () => {
    return hasUnknownLineItems(sale)
  }

  return (
    <>
      <SalePromotionBanner shouldShowPromoBanner={shouldShowPromoBanner()} />
      <SaleServiceBanner shouldShowServiceBanner={shouldShowServiceBanner()} />
      <SaleReturnBanner
        shouldShowReturnBanner={shouldShowBlindReturnBanner()}
      />
      <SaleErrorBanner shouldShowErrorBanner={shouldShowSaleErrorBanner()} />
    </>
  )
}
